import { TabPanelComponent } from './TabPanel'
import { TabPanelContainer } from './TabPanel.styles'
import { TabPanelDefault } from './TabPanelDefault'

export type { TabPanelProps } from './TabPanel'
export type { TabPanelDefaultProps } from './TabPanelDefault'

export const TabPanel = Object.assign(TabPanelComponent, {
  Default: TabPanelDefault,
  Styled: {
    Container: TabPanelContainer,
  },
})
